import React, { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useSelector } from "react-redux"

import { logout } from "../services/helper"
import ROUTES from "../services/routes"
import { IRedux } from "../services/types"
import useHistoryCustom from "../hooks/useHistoryCustom"

const initBurger = () => {
  const $navbarBurgers = Array.prototype.slice.call(
    document.querySelectorAll(".navbar-burger"),
    0
  )
  if ($navbarBurgers.length > 0) {
    $navbarBurgers.forEach(el => {
      el.addEventListener("click", () => {
        const { target } = el.dataset
        const $target = document.getElementById(target)
        if (!$target) return
        el.classList.toggle("is-active")
        $target.classList.toggle("is-active")
      })
    })
  }
}

interface ILink {
  label: string
  link: string
}

const Link = ({ label, link }: ILink) => {
  const history = useHistoryCustom()
  const location = useLocation()

  return (
    <a
      className={`navbar-item ${location.pathname === link && "is-active"}`}
      onClick={() => history.push(link)}
    >
      {label}
    </a>
  )
}

const NavBar = () => {
  const settings = useSelector((state: IRedux) => state.settings?.extended)

  useEffect(() => {
    initBurger()
  }, [])

  return (
    <nav
      className="navbar is-primary"
      role="navigation"
      aria-label="main navigation"
    >
      <div
        role="button"
        className="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbarBasicExample"
      >
        <span aria-hidden="true" />
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </div>

      <div id="navbarBasicExample" className="navbar-menu">
        <div className="navbar-start">
          <Link label="Liste des personnes inscrites" link={ROUTES.HOME} />
          {/*           <Link
            label="Liste des personnes inscrites"
            link={ROUTES.USERS_REGISTERED}
          /> */}
          <Link
            label="Inscrire une nouvelle personne"
            link={ROUTES.EVENTS_INSCRIPTION}
          />
          <Link label="Mes photos" link={ROUTES.PHOTOS} />
          {settings && !!settings.showUsersPresent && (
            <Link label="Liste des présents" link={ROUTES.USERS_PRESENT} />
          )}
          {settings && !!settings.showScanUserLink && (
            <Link label="Scanner" link={ROUTES.SCAN} />
          )}
        </div>

        <div className="navbar-end">
          <div className="navbar-item">
            <div className="buttons">
              <button
                type="button"
                className="button is-light"
                onClick={() => logout()}
              >
                Déconnexion
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default NavBar
